// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__nJ1el","current_link":"MenuLink_current_link__M1Uqm"};